import { Box } from '@mui/material';
import { Medal } from '../../icons/Medal/Medal';
import { font700Sx, fontSize14Sx } from '../../styles/Global.style';
import { Text } from '../Text/Text';
import { awardSx, inactive } from './Award.style';

export const Award = ({ text, color, isActive }) => {
  const inactiveSx = !isActive && inactive;

  return (
    <Box
      sx={{
        ...awardSx,
        ...inactiveSx,
      }}
    >
      <Medal color={color} />
      <Text
        variant="body2"
        text={text}
        sx={{ ...font700Sx, ...fontSize14Sx }}
      />
    </Box>
  );
};
